export default __webpack_public_path__ + "static/media/Pavel.0b11fa92.png";